export default "__VITE_ASSET__iWCjSn1r__"